import { cn } from "../../lib/utils";

/**
 * Brand mascot with the same float on web and desktop. The wrapper owns the
 * transform so `img { object-fit }` cannot swallow the animation, and the
 * padding keeps overflow-y-auto parents from clipping the travel.
 */
export function MorrowMascot({ className }: { readonly className?: string }) {
  return (
    <span className={cn("morrow-mascot-float flex shrink-0", className)}>
      <img
        alt=""
        aria-hidden="true"
        className="size-full object-contain"
        src="/brand/morrow-mascot.png"
      />
    </span>
  );
}
